// extracted by mini-css-extract-plugin
module.exports = {"starIcon":"CTAButton_starIcon__eYQZC"};